import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-lobby-status-tile',
  templateUrl: './lobby-status-tile.component.html',
  styleUrls: ['./lobby-status-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LobbyStatusTileComponent {

  @Input() title: string = '';
  @Input() value: number = 0;
  @Input() icon: string = '';

}
